/* Header cart drawer behaviour.
   Liquid-derived config (money format, cart routes) is read from data-* attributes
   on [data-cart-drawer] so this file can stay a static asset (no Liquid).
   Opens on a [data-cart-drawer-open] click or a `cart-drawer:open` document event;
   `cart:refresh` re-fetches contents. */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var moneyFormat = (drawer.getAttribute('data-money-format') || '').replace(/<[^>]*>/g, '');
  if (!moneyFormat) moneyFormat = '${{amount}}';
  var changeUrl = drawer.getAttribute('data-change-url') || '/cart/change';
  var cartUrl = drawer.getAttribute('data-cart-url') || '/cart';

  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  var toggles = document.querySelectorAll('[data-cart-drawer-open]');
  var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
  var itemsEl = drawer.querySelector('[data-cart-items]');
  var emptyEl = drawer.querySelector('[data-cart-empty]');
  var footerEl = drawer.querySelector('[data-cart-footer]');
  var subtotalEls = drawer.querySelectorAll('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var busy = false;
  var lastFocus = null;

  /* Per-variant stock cap (inventory_quantity, "deny" only) embedded on each line at
     server render; cart.js re-renders carry no inventory, so cache it by variant id
     and re-stamp it in itemHTML so the cap survives re-renders. */
  var maxByVariant = {};
  var lineMsgTimers = new WeakMap();
  var QTY_MAX_TOOLTIP = 'You cannot add more';

  function indexMax() {
    if (!itemsEl) return;
    itemsEl.querySelectorAll('[data-cart-item]').forEach(function (li) {
      var vid = li.getAttribute('data-variant-id');
      if (vid && li.hasAttribute('data-max')) maxByVariant[vid] = parseInt(li.getAttribute('data-max'), 10);
    });
  }
  function lineMax(li) { var m = li && li.getAttribute('data-max'); return (m == null || m === '') ? Infinity : parseInt(m, 10); }
  function lineMsgEl(li) { return li ? li.querySelector('[data-qty-msg]') : null; }
  /* Grey out "+" once the line holds every unit in stock, and explain why on hover.
     aria-disabled rather than the disabled attribute: a disabled button is removed
     from the a11y tree and, in several browsers, stops firing the hover that shows
     a title tooltip - so the explanation would never appear. The click handler
     below still guards, so this is presentation only. */
  function syncQtyButtons() {
    if (!itemsEl) return;
    itemsEl.querySelectorAll('[data-cart-item]').forEach(function (li) {
      var inc = li.querySelector('[data-qty-increase]');
      if (!inc) return;
      var input = li.querySelector('[data-qty-input]');
      var max = lineMax(li);
      var qty = parseInt(input ? input.value : '0', 10) || 0;
      var atMax = max !== Infinity && qty >= max;
      inc.classList.toggle('is-disabled', atMax);
      inc.setAttribute('aria-disabled', atMax ? 'true' : 'false');
      if (atMax) inc.setAttribute('title', QTY_MAX_TOOLTIP);
      else inc.removeAttribute('title');
    });
  }
  function showLineMsg(li, text) {
    var el = lineMsgEl(li); if (!el) return;
    var t = lineMsgTimers.get(el); if (t) { clearTimeout(t); lineMsgTimers['delete'](el); }
    el.textContent = text || ''; el.hidden = !text;
  }
  function flashLineMsg(li, text) {
    var el = lineMsgEl(li); if (!el) return;
    showLineMsg(li, text);
    lineMsgTimers.set(el, setTimeout(function () { showLineMsg(li, ''); }, 2500));
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, precision, thousands, decimal) {
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var match = moneyFormat.match(re);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return moneyFormat.replace(re, value);
  }

  function sizedImage(url, w) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + w : url + '?width=' + w;
  }

  function itemHTML(item) {
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
      ? '<p class="header-cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
    var img = item.image
      ? '<img src="' + sizedImage(item.image, 160) + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">' : '';
    var max = maxByVariant[item.id];
    var maxAttr = (max != null && !isNaN(max)) ? ' data-max="' + max + '"' : '';
    return '<li class="header-cart-drawer__item" data-cart-item data-line-key="' + item.key + '" data-variant-id="' + item.id + '"' + maxAttr + '>'
      + '<a href="' + item.url + '" class="header-cart-drawer__item-image">' + img + '</a>'
      + '<div class="header-cart-drawer__item-info">'
      + '<a href="' + item.url + '" class="header-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>'
      + variant
      + '<div class="header-cart-drawer__item-bottom">'
      + '<div class="header-cart-drawer__qty">'
      + '<button type="button" data-qty-decrease aria-label="Decrease quantity">&minus;</button>'
      + '<input type="text" inputmode="numeric" value="' + item.quantity + '" class="header-cart-drawer__qty-input" data-qty-input aria-label="Quantity">'
      + '<button type="button" data-qty-increase aria-label="Increase quantity">+</button>'
      + '</div>'
      + '<span class="header-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>'
      + '<p class="header-cart-drawer__qty-msg" data-qty-msg role="status" aria-live="polite" hidden></p>'
      + '</div>'
      + '<button type="button" class="header-cart-drawer__remove" data-cart-remove>Remove</button>'
      + '</div>'
      + '</li>';
  }

  function render(cart) {
    var empty = cart.item_count === 0;
    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(itemHTML).join('');
      itemsEl.hidden = empty;
    }
    if (emptyEl) emptyEl.hidden = !empty;
    if (footerEl) footerEl.hidden = empty;
    subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', empty);
    });
    syncQtyButtons();
  }

  function getCart() {
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    drawer.classList.add('is-loading');
    return fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {})
      .finally(function () { busy = false; drawer.classList.remove('is-loading'); });
  }

  function openDrawer(e) {
    lastFocus = document.activeElement;
    // Callers (e.g. add-to-cart) can pass a fresh cart in e.detail.cart so the
    // drawer renders its contents *before* it animates in — no blank/stale flash.
    // Otherwise we trust the server-rendered DOM and re-fetch in the background.
    var detailCart = e && e.detail && e.detail.cart;
    if (detailCart) render(detailCart);
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    if (closeBtn) closeBtn.focus();
    if (!detailCart) getCart().then(render).catch(function () {});
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  toggles.forEach(function (t) { t.addEventListener('click', openDrawer); });
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  if (itemsEl) {
    indexMax();
    syncQtyButtons();
    itemsEl.addEventListener('click', function (e) {
      var li = e.target.closest('[data-cart-item]');
      if (!li) return;
      var key = li.getAttribute('data-line-key');
      var input = li.querySelector('[data-qty-input]');
      var qty = parseInt(input ? input.value : '0', 10) || 0;
      var max = lineMax(li);
      if (e.target.closest('[data-qty-increase]')) {
        if (max !== Infinity && qty >= max) { flashLineMsg(li, 'Maximum quantity available is ' + max); return; }
        changeLine(key, qty + 1);
      }
      else if (e.target.closest('[data-qty-decrease]')) changeLine(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-cart-remove]')) changeLine(key, 0);
    });
    // Block non-numeric input before it lands so the existing quantity (and cursor) is
    // left untouched; just flash the message. (input handler below is a fallback.)
    itemsEl.addEventListener('beforeinput', function (e) {
      var input = e.target.closest('[data-qty-input]'); if (!input) return;
      if (e.data != null && /\D/.test(e.data)) { e.preventDefault(); flashLineMsg(input.closest('[data-cart-item]'), 'Only numeric characters are allowed'); }
    });
    itemsEl.addEventListener('input', function (e) {
      var input = e.target.closest('[data-qty-input]'); if (!input) return;
      var li = input.closest('[data-cart-item]');
      var hadBad = false;
      var cleaned = input.value.replace(/[^0-9]/g, '');
      if (cleaned !== input.value) { input.value = cleaned; hadBad = true; }
      var max = lineMax(li);
      var val = parseInt(input.value, 10);
      if (max !== Infinity && !isNaN(val) && val > max) showLineMsg(li, 'Maximum allowed quantity is ' + max);
      else if (hadBad) flashLineMsg(li, 'Only numeric characters are allowed');
      else showLineMsg(li, '');
      syncQtyButtons();
    });
    itemsEl.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]'); if (!input) return;
      var li = input.closest('[data-cart-item]');
      var max = lineMax(li);
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 1) { qty = 1; input.value = 1; } // clearing the field shouldn't remove the line — use Remove
      if (max !== Infinity && qty > max) { qty = max; input.value = max; flashLineMsg(li, 'Maximum allowed quantity is ' + max); }
      changeLine(li.getAttribute('data-line-key'), qty);
    });
  }

  // Hooks so other scripts (e.g. a future add-to-cart handler) can drive the drawer.
  document.addEventListener('cart-drawer:open', openDrawer);
  document.addEventListener('cart:refresh', function () { getCart().then(render).catch(function () {}); });
})();
